import {
  Box, Divider, Stack, Typography,
} from '@mui/material';
import React from 'react';
import { useTranslation } from 'react-i18next';
import moment from 'moment/moment';
import STRING_KEYS from '../../../language/keys';
import { useGetCreditAllocations } from '../../../hooks/useAccount';
import { DATE_FORMAT } from '../../../consts';
import { CreditsAllocationType } from '../../../consts/enums';
import { accountCreditAllocationsStyle } from './account-credit-allocations.style';

type AccountCreditAllocationsProps = {
  accountId: string;
};

export const AccountCreditAllocations = ({
  accountId,
}: AccountCreditAllocationsProps): JSX.Element => {
  const { t: translate } = useTranslation();

  const { data: { creditAllocations = [] } = {} } = useGetCreditAllocations(
    accountId,
  );

  const displayedAllocations = creditAllocations.filter(({ allocationType }) => allocationType === CreditsAllocationType.Purchase);

  return (
    <Box>
      <Typography variant="h6" sx={ accountCreditAllocationsStyle.Typography.sx }>
        {translate(STRING_KEYS.CREDIT_ALLOCATIONS.TITLE)}
      </Typography>

      {displayedAllocations.length > 0 ? (
        <Stack direction="column" spacing="16px">
          {displayedAllocations.map((allocation, index) => (
            <Stack key={ allocation.id } direction="column">
              {index !== 0 && <Divider sx={ { marginBlockEnd: '8px' } } />}

              <Typography>
                {allocation.totalAllocatedCredits} credits were allocated.
              </Typography>

              <Typography variant="caption">
                User: {allocation.addedBy}
              </Typography>

              <Typography variant="caption">
                {moment(new Date(allocation.allocatedAt)).format(
                  DATE_FORMAT.HISTORY,
                )}
              </Typography>
            </Stack>
          ))}
        </Stack>
      ) : (
        <Typography>
          {translate(STRING_KEYS.CREDIT_ALLOCATIONS.NO_ALLOCATIONS)}
        </Typography>
      )}
    </Box>
  );
};
